export default "__VITE_ASSET__avLAJkcf__"